import React from 'react'

import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'

import type { PostInfoV2 } from '@page/post-v2/types'

import './PostPageV2Content.scss'

interface PostPageV2ContentProps {
    postInfo?: PostInfoV2 | undefined | null
    isLoading?: boolean
}

const baseClass = 'PostPageV2Content'

function PostPageV2Content({ postInfo, isLoading }: PostPageV2ContentProps) {
    if (isLoading) {
        return (
            <div className={baseClass}>
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'40%'}
                    height={40}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'40%'}
                    height={40}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
                <ApplySkeleton
                    isLoading={isLoading}
                    width={'100%'}
                    height={20}
                    borderRadius="99999"
                    style={{
                        marginBottom: '1rem',
                    }}
                />
            </div>
        )
    }

    if (!postInfo?.data?.body) {
        return null
    }

    return <div className={baseClass} dangerouslySetInnerHTML={{ __html: postInfo?.data?.body ?? '' }}></div>
}

export default PostPageV2Content
